import React from 'react';

import { ErrorContainer, ErrorMessageWrapper, ErrorHeader, ErrorText } from './response-error.styled';
import ErrorImage from './error-image';

const GenericError = () => {
  return (
    <ErrorMessageWrapper>
      <ErrorContainer>
        <ErrorImage />
        <ErrorHeader>We are sorry, this form is temporarily unavailable</ErrorHeader>
        <ErrorText>
          <p>Kindly contact the form owner. <span style={{display: 'block'}}>If you are the form owner, kindly visit your forms page.</span></p>
        </ErrorText>
      </ErrorContainer>
    </ErrorMessageWrapper>
  );
};

export default GenericError;
